import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 4C5 2.89543 5.89543 2 7 2H19.7574C20.2878 2 20.7965 2.21071 21.1716 2.58579L26.4142 7.82843C26.7893 8.2035 27 8.71221 27 9.24264V28C27 29.1046 26.1046 30 25 30H7C5.89543 30 5 29.1046 5 28V4Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <rect opacity="0.5" x="10" y="19" width="9" height="2" rx="1" fill="#0090FF" />
      <rect opacity="0.5" x="10" y="23" width="12" height="2" rx="1" fill="#0090FF" />
      <g opacity="0.5">
        <path
          d="M11.5 14C10.9477 14 10.5 14.4477 10.5 15C10.5 15.5523 10.9477 16 11.5 16L11.5 14ZM14.2348 10C14.787 10 15.2348 9.55228 15.2348 9C15.2348 8.44771 14.787 8 14.2348 8L14.2348 10ZM13.5076 15L13.5076 16L13.5076 15ZM14.2348 8L12.5076 8L12.5076 10L14.2348 10L14.2348 8ZM12.5076 13.0152L13.5076 13.0152L13.5076 11.0152L12.5076 11.0152L12.5076 13.0152ZM13.5076 14L11.5 14L11.5 16L13.5076 16L13.5076 14ZM14 13.5076C14 13.7795 13.7795 14 13.5076 14L13.5076 16C14.8841 16 16 14.8841 16 13.5076L14 13.5076ZM13.5076 13.0152C13.7796 13.0152 14 13.2357 14 13.5076L16 13.5076C16 12.1311 14.8841 11.0152 13.5076 11.0152L13.5076 13.0152ZM10 10.5076C10 11.8925 11.1227 13.0152 12.5076 13.0152L12.5076 11.0152C12.2273 11.0152 12 10.7879 12 10.5076L10 10.5076ZM12.5076 8C11.1227 8 10 9.12269 10 10.5076L12 10.5076C12 10.2273 12.2273 10 12.5076 10L12.5076 8Z"
          fill="#0090FF"
        />
        <path d="M12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8V9H12V8Z" fill="#0090FF" />
        <path d="M12 15H14V16C14 16.5523 13.5523 17 13 17C12.4477 17 12 16.5523 12 16V15Z" fill="#0090FF" />
      </g>
    </svg>
  );
};

export default Svg;
